import * as yup from 'yup';
import { Row, RenderConfig, SelectInput, TextInput, AsyncSelect, CASE } from 'commons-ui';

const BOOLEAN_OPTIONS = [
	{ id: true, label: 'True' },
	{ id: false, label: 'False' }
];

export const FORM_FIELD_KEYS = {
	USERNAME: 'userName',
	ROLE_ID: 'roleId',
	IS_DISABLED: 'isDisabled',
	EMAIL: 'email'
};
export const validationSchema = yup.object().shape({
	email: yup.string().required('Email ID is a required'),
	roleId: yup.string().required('Role is required')
});

export const FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.USERNAME),
	new Row(FORM_FIELD_KEYS.ROLE_ID),
	new Row(FORM_FIELD_KEYS.IS_DISABLED),
	new Row(FORM_FIELD_KEYS.EMAIL)
];

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.USERNAME]: new RenderConfig()
		.setName('userName')
		.setLabel('Username')
		.setRenderer(TextInput)
		.setRenderProps({ isEditable: { create: true, edit: false }, required: true }),
	[FORM_FIELD_KEYS.ROLE_ID]: new RenderConfig()
		.setName('roleId')
		.setLabel('Role')
		.setRenderer(AsyncSelect)
		.setRenderProps({
			isEditable: { create: true, edit: true, required: true }
		}),
	[FORM_FIELD_KEYS.IS_DISABLED]: new RenderConfig()
		.setName('isDisabled')
		.setLabel('Is Disabled')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: false, edit: true },
			isHidden: { create: true, edit: false },
			options: BOOLEAN_OPTIONS
		}),
	[FORM_FIELD_KEYS.EMAIL]: new RenderConfig()
		.setName('email')
		.setLabel('Email ID')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: false },
			letterCase: CASE.LOWERCASE
		})
};
